<template lang="pug">
  div(data-testid="content-accessed")
    section.content-header
      app-messages(:errorMessages="errors", :successMessages="successes")

      h1 最近見た名刺

    section.content
      .bcard-btnbar.clearfix
        //func-export(:checked-ids="checkedIds", :use-search="isAllPagesChecked", :conds="conditions")
        //|
        //|
        func-tag(:checked-ids="checkedIds", :use-search="isAllPagesChecked", :conds="conditions")
        |
        |
        func-edit(:checked-ids="checkedIds")
        |
        |
        func-favorite(:checked-ids="checkedIds")

      .panel.panel-default
        .panel-heading.text-right
          portal-target(name="list_mode", tag="span")

        loading(v-if="isLoading")
        card-list(
          v-else-if="list.length > 0",
          v-model="list",
          :pCheckedIds="checkedIds",
          :use-favorite="true",
          @checkAll="checkAll",
          @checkItem="checkItem"
        )
          template(slot="thDate")
            | 閲覧日
            i.fa.bcard-table-sort-header-icon.fa-sort-desc
          template(slot="tdDate", slot-scope="{item}")
            | {{item.formatted_refdate}}

        .panel-body.text-center(v-else) 最近見た名刺はありません。

      app-pagination(:is-loading="isLoading", :pagination="pagination", @change="getList")
</template>

<script>
import mixinList from '@/mixins/list'
import AppMessages from '@/components/molecules/AppMessages'
import AppPagination from '@/components/molecules/AppPagination'
import AppSortmenu from '@/components/molecules/AppSortmenu'
import Loading from '@/components/molecules/Loading'
import FuncExport from '@/components/organisms/functions/FuncExport'
import FuncTag from '@/components/organisms/functions/FuncTag'
import FuncEdit from '@/components/organisms/functions/FuncEditCard'
import FuncFavorite from '@/components/organisms/functions/FuncFavorite'
import FuncAdvancedSearch from '@/components/organisms/functions/FuncAdvancedSearch'
import CardList from '@/components/organisms/lists/CardList'

// mock用
import { repository as repoEnv } from 'static/config'
const IS_MOCK = repoEnv.isMock

export default {
  name: 'Browsing',
  components: {
    AppMessages,
    AppPagination,
    AppSortmenu,
    Loading,
    FuncExport,
    FuncTag,
    FuncEdit,
    FuncFavorite,
    FuncAdvancedSearch,
    CardList
  },
  mixins: [ mixinList ],
  data () {
    return {
      isLoading: true,

      // 初期条件
      initParams: {
        // ページ条件
        page: { page: 1 },
        // ソート条件
        sort: { sort_item: 'name', direction: 'asc' },
        // 検索条件
        conds: {
          search_target: 'acc' // APIでは使わないけどfunctionsで使うので設定しておく
        }
      }
    }
  },
  watch: {
    // storeのwatchの仕方は他にもある
    // https://stackoverflow.com/questions/43270159/vuejs-2-how-to-watch-store-values-from-vuex
    '$store.state.base.bcardListReloader' (bcardListReloader) {
      if (bcardListReloader) {
        this.getList()
      }
    }
  },
  created () {
    // サイドメニューから遷移した場合、mixinListで取得しているstoreの条件を上書きする
    if (this.$route.params.init) {
      this.pagination = Object.assign({}, this.initParams.page)
      this.conditions = Object.assign({}, this.initParams.conds)
    }

    // 初期データ取得
    this.getList()
  },
  methods: {
    /**
     * 一覧取得処理
     * @params options
     *    page: ページ条件
     *    sort: ソート条件
     *    conds: 検索条件
     */
    getList (options) {
      const vm = this
      options = options || {}

      let page = options.page || this.pagination.current_page || 1
      let conds = options.conds || this.conditions || {}

      let params = {
        // page
        page,
        // conditions
        search_target: conds.search_target
      }

      this.clearErrorMessages()
      this.isLoading = true

      // 一覧取得
      this.sendListRequest({
        repo: this.isMgmt ? 'managebcard' : 'bcard',
        method: 'searchAcc',
        params,
        onSuccess (response) {
          // mock用データ改造
          if (IS_MOCK) {
            for (let item of vm.list) {
              item.isFavorite = (item.id % 2 === 1) ? '1' : '0'
              item.is_latest = (item.id % 2 === 1 ? '1' : '0') // 過去名刺パターン
              item.formatted_exdate = '2019/01/11'
            }
          }
        },
        finally () {
          vm.isLoading = false
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/pages/box/FilterAccessed.vue